<template>
  <section class="grey lighten-2 footer-1">
    <v-container fluid text-xs-center style="padding:0;">
      <v-layout row wrap>
        <v-flex xs12 sm12 md4 v-for="(icon, i) in sociais" :key="i">
          <v-btn
            depressed
            :color="icon.color"
            dark
            large
            block
            :href="icon.link"
            style="padding-top:60px;padding-bottom:60px;margin:0;border-radius:0;"
          >
            <i :class="icon.icon" style="margin-right:5px; font-size:2em;"></i>
            <div>{{icon.text}}</div>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    sociais: [
      {
        icon: "fab fa-facebook",
        link: "https://www.facebook.com/escolaengenhocampeche",
        text: "Curta no Facebook",
        color: "blue lighten-1"
      },
      {
        icon: "fab fa-instagram",
        link: "https://www.instagram.com/escolaengenho",
        text: "Siga no Instagram",
        color: "purple lighten-2"
      },
      {
        icon: "fab fa-whatsapp",
        link:
          "https://wa.me/5548999226535?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20%20site%20da%20escola.",
        text: "Fale pelo WhatsApp",
        color: "green lighten-1"
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
</style>
